import { RemoteMainPageConfig } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'


export type SetDefaultMainPageConfigInput = {
  mainPageConfigId: GQL_ID
}

export type SetDefaultMainPageConfigResponse = {
  setDefaultMainPageConfig: RemoteMainPageConfig
}

export const GQL_MUTATION_SET_DEFAULT_MAIN_PAGE_CONFIG = gql`
  mutation setDefaultMainPageConfig($mainPageConfigId: ID!) {
    setDefaultMainPageConfig(mainPageConfigId: $mainPageConfigId) {
      id
      isDefault
    }
  }
`

export const useMUtateSetDefaultMainPageConfig = () =>
  useMutation<SetDefaultMainPageConfigResponse, SetDefaultMainPageConfigInput>(GQL_MUTATION_SET_DEFAULT_MAIN_PAGE_CONFIG, {
    refetchQueries: [ 'allMainPageConfigs' ]
  })